import { getValidatePinUrl } from 'config/api';

import { PIN_TYPES } from 'store/user/reducer.types';

import NagraInstance from 'utils/axios/nagra/DefaultInstance';

export default async function validatePin(pin: string) {
    return NagraInstance.post(
        getValidatePinUrl(),
        {
            type: PIN_TYPES.AccessPin,
            value: pin,
        },
        { headers: { 'nv-tenant-id': 'nagra' } },
    );
}
